import type { CSSProperties } from 'react'
import styles from './Tile.module.css'

interface TileProps {
  /** Unicode glyph — the design uses no SVG anywhere. */
  glyph: string
  label: string
  hint: string
  /** Accent colour for the top border and the icon chip. */
  accent: string
  /** Ink colour that reads on the accent. */
  iconInk: string
  chevron: string
  onClick?: () => void
  disabled?: boolean
  /** Shown instead of the chevron when the feature is deferred. */
  deferredNote?: string
}

export function Tile({
  glyph,
  label,
  hint,
  accent,
  iconInk,
  chevron,
  onClick,
  disabled = false,
  deferredNote,
}: TileProps) {
  const style = {
    '--tile-accent': accent,
    '--tile-icon-ink': iconInk,
    '--tile-chevron': chevron,
  } as CSSProperties

  return (
    <button type="button" className={styles.tile} style={style} onClick={onClick} disabled={disabled}>
      <div className={styles.head}>
        <span className={styles.icon} aria-hidden="true">
          {glyph}
        </span>
        <span className={styles.spring} />
        {deferredNote === undefined ? (
          <span className={styles.chevron} aria-hidden="true">
            &#x2190;
          </span>
        ) : (
          <span className={styles.deferred}>{deferredNote}</span>
        )}
      </div>

      <span className={styles.label}>{label}</span>
      <span className={styles.hint}>{hint}</span>
    </button>
  )
}
